import { Directive, forwardRef, Input } from '@angular/core';
import { Validator, AbstractControl, NG_VALIDATORS } from '@angular/forms';

export const CONTROLES_INTERNOS_VALIDATOR: any = {
  provide: NG_VALIDATORS,
  useExisting: forwardRef(() => ControlesinternosValidator),
  multi: true
};

@Directive({
  selector: '[validateCountry][formControlName],[validateCountry][formControl],[validateCountry][ngModel]',
  providers: [CONTROLES_INTERNOS_VALIDATOR]
})

export class ControlesinternosValidator implements Validator {
  @Input() validateCountry: string;

  validate(c: AbstractControl): { [key: string]: any } {
    // self value
    let country = c.value;
    let phone = c.root.get(this.validateCountry);
    phone.updateValueAndValidity();
    return null;
  }
}


// WEBPACK FOOTER //
// ./src/pipes/controlesinternos-validator.ts